import { BannerResponse, GetBannersParams, NotifictionsResponse } from '@/types/Content';
import apiSlice from './apiSlice';

export const contentApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getBanners: builder.query<BannerResponse, GetBannersParams>({
      query: (params) => ({
        url: '/banners',
        method: 'GET',
        params,
      }),
      providesTags: ['Content'],
    }),
    getNotifications: builder.query<
      NotifictionsResponse,
      { type: 'Alert' | 'Information'; page?: number; limit?: number }
    >({
      query: (params) => ({
        url: '/notifications',
        method: 'GET',
        params,
      }),
      providesTags: ['Content'],
    }),
  }),
});

export const { useGetBannersQuery, useGetNotificationsQuery } = contentApi;
